<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacao.exame"
                    :request-query-string-params="{ not_id: examesPrestadoresIds }"
                    :search-fields="fields.grupoExame"
                    :validations="validations.grupoExame"
                    label="Grupo de exame / Exame"
                    :text-field="i => i.codigo ? `${this.formatProcedimento(i.codigo)} - ${i.nome}` : i.nome"
                    uppercase
                    v-model="model.grupoExame"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click="$refs.Form.validate(add)"
                    color="primary"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, error, object, formats } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {

            return {
                grupoExame: { required: true },
            }
        },
        examesPrestadoresIds() {

            return this.prestador.exames.map(e => e.id)
        }
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao')
        }
    },
    data: () => ({
        fields: {
            grupoExame: [
                { key: 'item.codigo', searchable: true },
                { key: 'item.nome', searchable: true },
            ],
        },
        model: {
            grupoExame: null,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        add() {

            if (this.model.grupoExame.origem === 'exame') {

                this.prestador.exames.push(this.prepareData(this.model.grupoExame))

                this.resetForm()
            }
            else {

                this.getExames().then(exames => {

                    exames.filter(e => !this.examesPrestadoresIds.includes(e.id))
                        .forEach(exame => this.prestador.exames.push(this.prepareData(exame)))

                    this.resetForm()
                })
            }
        },
        async getExames() {

            let exames = [];

            this.setLoading()

            try {

                exames = (await this.repositories.parametrizacao.list({
                    listar: 'exames',
                    grupo_id: this.model.grupoExame.id
                })).data
            }
            catch (error) {

                this.handleError(error)
            }
            finally {

                this.unsetLoading()
            }

            return exames
        },
        prepareData(exame) {

            exame = this.clone(exame)
            exame.ativo = true

            return exame

        },
        resetForm() {

            this.model.grupoExame = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        }
    },
    mixins: [repository, error, object, formats],
    props: {
        prestador: { type: Object, required: true },
    },
}
</script>